import { createContext, useContext } from 'react';
import type { ImpersonatedPractice } from './ImpersonationContext';

interface ImpersonationContextValue {
  impersonatedPractice: ImpersonatedPractice | null;
  startImpersonation: (practice: ImpersonatedPractice) => void;
  stopImpersonation: () => void;
  /** Updates the viewed practice's name after it is renamed; ignored for any other practice. */
  renameImpersonatedPractice: (id: string, name: string) => void;
}

export const ImpersonationContext = createContext<ImpersonationContextValue>({
  impersonatedPractice: null,
  startImpersonation: () => {},
  stopImpersonation: () => {},
  renameImpersonatedPractice: () => {},
});

export function useImpersonation() {
  return useContext(ImpersonationContext);
}
